






































































import CSlider from '~/components/shared/configurable/slider/CSlider.vue'
import UrlHistoryService from '~/services/url/history/UrlHistoryService'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import {
  SET_INSTALLMENTS_DOWNPAYMENT,
  SET_INSTALLMENTS_NUMBER_OF_INSTALLMENTS
} from '~/store/modules/shared/classifieds/view/mutation-types'
import {
  INSTALLMENTS_DOWNPAYMENT_PARAM_NAME,
  INSTALLMENTS_NUM_OF_INSTALLMENTS_PARAM_NAME
} from '~/constants/finance/installments'
import { debounce } from '~/utils/function'
import InstallmentsService from '~/services/classified/finance/InstallmentsService'
import { formatNumber } from '~/utils/number'
import CPrice from '~/components/shared/configurable/CPrice.vue'
import {
  defineComponent,
  computed,
  onMounted,
  useRoute,
  watch
} from '~/utils/nuxt3-migration'
import { useI18n } from '~/compositions/i18n'
import { useDeps } from '~/compositions/dependency-container'
import { useNamespacedStore } from '~/compositions/store'
import PopularityService from '~/services/popularity/PopularityService'
import { v4 as uuidv4 } from 'uuid'

export default defineComponent({
  components: {
    CPrice,
    CSlider
  },
  setup() {
    const { state, getters, commit } = useNamespacedStore(CLASSIFIED_VIEW_NS)
    const randomId = uuidv4()

    const [installmentsService, urlHistoryService, popularityService] = useDeps(
      InstallmentsService,
      UrlHistoryService,
      PopularityService
    )
    const route = useRoute()
    const { t } = useI18n()

    const classifiedRawPrice = computed(
      () => state.classified?.price.extra.raw_price || 0
    )
    const inClassifiedView = computed(() => {
      return route.value.name?.startsWith('__classifieds_view')
    })

    const downpayment = computed(() => state.installments.downpayment)
    const numberOfInstallments = computed(
      () => state.installments.numberOfInstallments
    )
    const maxInstallments = computed(
      () => state.classified.finance.options.maxInstallments
    )
    const price = computed(() => state.classified.finance.price)
    const interestPercentage = computed(
      () => state.classified.finance.options.interestPercentage
    )
    const minDownpayment = computed(
      () => state.classified.finance.options.minDownpayment
    )

    const hasValidDownpayment = computed(() => {
      return getters('downpaymentIsValid')(installmentsService)
    })
    const monthlyInstallmentAmount = computed(() => {
      return getters('getMonthlyInstallmentAmount')(installmentsService)
    })

    const handleNumberOfInstallmentsChange = (value: number) => {
      commit(SET_INSTALLMENTS_NUMBER_OF_INSTALLMENTS, value)
      urlHistoryService.replaceQueryParams({
        [INSTALLMENTS_NUM_OF_INSTALLMENTS_PARAM_NAME]: value
      })
    }

    const downpaymentChange = debounce((downpayment: string) => {
      commit(SET_INSTALLMENTS_DOWNPAYMENT, parseFloat(downpayment))
      urlHistoryService.replaceQueryParams({
        [INSTALLMENTS_DOWNPAYMENT_PARAM_NAME]: downpayment
      })
    }, 1000)

    const formatDownpayment = (d: any) => {
      return d.toString().substring(0, 6)
    }

    const downpaymentInvalidErrorMessage = computed(() => {
      return `${t('the::female')} ${t('downpayment').toLowerCase()} ${t(
        'must be between'
      ).toLowerCase()} ${formatNumber(minDownpayment.value)}€ ${t(
        'and'
      ).toLowerCase()} ${formatNumber(price.value)}€`
    })

    const sliderOptions = computed(() => {
      return {
        processStyle: {
          backgroundColor: '#1976d2'
        },
        tooltipStyle: {
          backgroundColor: '#1976d2'
        }
      }
    })

    onMounted(() => {
      const installmentsDownpayment =
        route.value.query['installments-downpayment']
      const installmentsNumOfInstallments =
        route.value.query['installments-num-of-installments']

      if (installmentsDownpayment) {
        commit(
          SET_INSTALLMENTS_DOWNPAYMENT,
          parseFloat(installmentsDownpayment as string)
        )
      }

      if (installmentsNumOfInstallments) {
        commit(
          SET_INSTALLMENTS_NUMBER_OF_INSTALLMENTS,
          parseFloat(installmentsNumOfInstallments as string)
        )
      }
    })

    const loanAmount = computed(() => {
      return (
        parseFloat(classifiedRawPrice.value) - parseFloat(downpayment.value)
      )
    })

    watch(loanAmount, () => {
      recordInteraction()
    })
    watch(numberOfInstallments, () => {
      recordInteraction()
    })

    const recordInteraction = () => {
      let classified = {}

      if (inClassifiedView.value && state.classified) {
        const make = state.adsTargetings?.find(t => t.name === 'make')
        const model = state.adsTargetings?.find(t => t.name === 'model')
        const monthAndYear = state.classified.specifications.find(
          s => s.name === 'registration'
        )

        classified = {
          loan_classified_id: state.classifiedId,
          loan_classified_make: make?.value.length ? make.value[0] : undefined,
          loan_classified_model: model?.value.length
            ? model.value[0]
            : undefined,
          loan_classified_registration_year: monthAndYear?.value,
          loan_classified_price: classifiedRawPrice.value
        }
      }

      popularityService.recordEvent('public_loan_calculator_interaction', {
        amount: loanAmount.value,
        installments_count: numberOfInstallments.value,
        merchant: 'finance',
        session_id: randomId,
        ...classified
      })
    }

    return {
      downpayment,
      numberOfInstallments,
      maxInstallments,
      price,
      interestPercentage,
      minDownpayment,
      hasValidDownpayment,
      monthlyInstallmentAmount,
      sliderOptions,
      handleNumberOfInstallmentsChange,
      downpaymentChange,
      formatDownpayment,
      downpaymentInvalidErrorMessage
    }
  }
})
